import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getMTPList = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.MTP.GET_MTP_LIST,
        { params: params }
    );
    console.log(
        "🚀 ~ file: MtpRepository.ts ~ line 9 ~ getMTPList ~ response",
        response?.data
    );

    return response?.data;
};
export const getMTPMonths = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.MTP.GET_MTP_MONTHS,
        { params: params }
    );
    console.log(
        "🚀 ~ file: MtpRepository.ts ~ line 22 ~ getMTPMonths ~ response",
        response?.data?.data
    );
    let dt = response?.data?.data
    if (dt && Object.keys(dt || {})?.length > 0) {
        let formattedData = Object.keys(dt || {})?.reduce((arr: any, item: any) => {
            arr.push({ id: `${item}`, label: dt[item] })
            return arr;
        }, [])
        return { response, data: formattedData }
    }

    return { response, data: [] }
};
export const getMTPStatus = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(API_ENDPOINTS.MTP.GET_MTP_STATUS);
    console.log(
        "🚀 ~ file: MtpRepository.ts ~ line 32 ~ getMTPStatus ~ response",
        response?.data?.data
    );
    let dt = response?.data?.data
    if (dt && Object.keys(dt || {})?.length > 0) {
        let formattedData = Object.keys(dt || {})?.reduce((arr: any, item: any) => {
            arr.push({ id: `${item}`, label: dt[item] })
            return arr;
        }, [])
        return { response, data: formattedData }
    }

    return { response, data: [] }
};

export const getMTPActions = async () => {
    const response = await axiosInstance.get(API_ENDPOINTS.MTP.GET_MTP_ACTIONS);
    console.log(
        "🚀 ~ file: MtpRepository.ts ~ line 56 ~ getMTPActions ~ response",
        response?.data?.data
    );
    let dt = response?.data?.data
    if (dt && Object.keys(dt || {})?.length > 0) {
        let formattedData = Object.keys(dt || {})?.reduce((arr: any, item: any) => {
            arr.push({ id: `${item}`, label: dt[item] })
            return arr;
        }, [])
        return { response, data: formattedData }
    }

    return { response, data: [] }
};

export const addMTPForMonth = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.MTP.ADD_MTP_FOR_MONTH, body);
};


export const updateMTPStatus = async (body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.MTP.UPDATE_MTP_STATUS}`, body);
};


export const getMTPDayById = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.MTP.GET_MTP_DAY_BY_ID,
        { params: params }
    );
    console.log(
        "🚀 ~ file: MtpRepository.ts ~ line 88 ~ getMTPDayById ~ response",
        response?.data
    );

    return response?.data;
};
 
export const getMtpDayCustomers = async(id:number |undefined,beatID?:number|undefined)=>{
  let response = await axiosInstance.get(`${API_ENDPOINTS.MTP.GET_MTP_DAY_CUSTOMER}/${id}`, { params: { beatId: beatID } });
  const rowData = await response.data;
  const formatedData = Array.isArray(rowData?.data.CustomersList)?
    rowData.data.CustomersList.map((item:any)=>({
          customerName:item.OutletName,
          BeatId:item.BeatId,
          OutletOrgId:item.OutletOrgId
    })):[]  
    return{formatedData,rowData};
}


export const getMtpDayBeatTown = async(id:number |undefined,agendaControlType?:string )=>{
  let queryString =`${id}?${agendaControlType}`
  let response = await axiosInstance.get(`${API_ENDPOINTS.MTP.GET_MTP_DAY_BEAT_TOWN}/${queryString}`);
  const rowData = await response.data;

  const formatedData = Array.isArray(rowData.data.BeatTownData)?
    rowData.data.BeatTownData.map((item:any)=>({
          BeatId:item.BeatId ||'-',
          BeatName:item.BeatName ||'-',
          TownName:item.BeatTownName ||'-',
          Itownid:item.Itownid || '-'
    })):[]  
    // console.log('formatedData====>formatedData',formatedData);
    return{formatedData,rowData};
}


export const getTourPlanByMTPDayId = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.MTP.GET_TOUR_PLAN_BY_MTP_DAY_ID,
        { params: params }
    );
    console.log(
        "🚀 ~ file: MtpRepository.ts ~ line 88 ~ getTourPlanByMTPDayId ~ response",
        response?.data
    );
    return response?.data;
};
export const getTerritoriesForMTP = async (positionId:any) => {
    const url = `?positionId=${positionId}`
    const response = await axiosInstance.get(`${API_ENDPOINTS.MTP.GET_MTP_TERRITORIES}${url}`,);
    const rowData = await response.data;

    const formatedData = Object.entries(rowData?.data || {}).map(([key,val])=>({
     id:key,
     label:String(val)
    }));
   return{formatedData,rowData};
};

export const Add_MTP_Tour_Plan = async (
  mtpDayId: number,
  agendaControlType: string,
  agendaId: number,
  territoryId: number,
  townId?: number | null,
  beatId?: number,
  outletOrgDataId?: number
) => {
  const params: Record<string, any> = {
    agendaControlType,
    agendaId,
    territoryId,
  };

  if (townId) params.townId = townId;
  if (beatId) params.beatId = beatId;
  if (outletOrgDataId) params.outletOrgDataId = outletOrgDataId;
  const response = await axiosInstance.post(
    `${API_ENDPOINTS.MTP.ADD_TOUR_PLAM}/${mtpDayId}`,
    {},
    { params }
  );
  return response.data;
};


// /admin/api/updateTourplan/{mtpDayId}

export const UpdateMTPTourPlan = async ({
  mtpDayId,
  tourplanId,
  agendaControlType,
  agendaId,
  territoryId,
  townId,
  beatId,
  outletOrgDataId,
}: {
  mtpDayId: number;
  tourplanId:number,
  agendaControlType: string;
  agendaId: number;
  territoryId: number;
  townId?: number;
  beatId?: number;
  outletOrgDataId?: number;
}) => {
  // Build query params dynamically in js

  const params = new URLSearchParams({
    mtpDayId: mtpDayId.toString(),
    agendaControlType,
    tourplanId:tourplanId.toString(),
    agendaId: agendaId.toString(),
    territoryId: territoryId.toString(),
  });

  if (townId !== undefined) params.append("townId", townId.toString());
  if (beatId !== undefined) params.append("beatId", beatId.toString());
  if (outletOrgDataId !== undefined) params.append("outletOrgDataId", outletOrgDataId.toString());

  const url =`${mtpDayId}?${params.toString()}`;
  let response = await axiosInstance.put(`${API_ENDPOINTS.MTP.UPDATE_MTP_TOUR_PLAN}/${url}`);


};
